import React, { useContext, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import PosterForm from './form/PosterForm';
import { CityContext } from '../../context/City';
import LoadingSpinner from './UI/LoaderSpinner';
import useEndpoints from '../../API/apiConfig';
import { useObserver } from '../../hooks/useObserver';
import { getPagesCount } from '../../utils/pages';

const PostersManager = () => {
    const user = JSON.parse(localStorage.getItem('user'));
    const token = user?.data?.token;

    const { cities } = useContext(CityContext);
    const endpoints = useEndpoints();
    const [posters, setPosters] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [currentPoster, setCurrentPoster] = useState();
    const [isCurrentPosterLoading, setIsCurrentPosterLoading] = useState(false)
    const [page, setPage] = useState(1);
    const [selectedCityId, setSelectedCityId] = useState(user.data.idCity == -1 ? '' : cities[0].id);
    const lastElement = useRef()
    const [totalPages, setTotalPages] = useState(0)


    const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
    };

    const headersFile = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'multipart/form-data'
    };

    const fetchPosters = async (page) => {
        setIsLoading(true)
        try {
            const endpoint = selectedCityId || selectedCityId == 0 && typeof selectedCityId == "number" ? endpoints.POSTERS_ALL_WITH_CITY : endpoints.POSTERS_ALL;
            const response = await axios.get(`${endpoint}?pageNumber=${page}&pageSize=5${selectedCityId || selectedCityId == 0 && typeof selectedCityId == "number" ? `&cityId=${selectedCityId}` : ''}`, { headersFile });
            setPosters(prevPosters => [...prevPosters, ...response.data]);
            setIsLoading(false);
            const totalCount = response.headers['x-total-count']
            setTotalPages(getPagesCount(totalCount, 5))
        } catch (error) {
            console.error("Ошибка при загрузке постеров:", error);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        fetchPosters(page);
    }, [page, selectedCityId]);

    const handleCityChange = (event) => {
        setSelectedCityId(event.target.value);
        setPosters([]);
        setPage(1);
    };

    const createPoster = async (data) => {
        try {
            await axios.post(`${endpoints.POSTERS_ADD}`, data, { headers: headersFile });
            if (page == 1) {
                fetchPosters(page)
            }
            setPage(1);
            setPosters([]);
        } catch (error) {
            console.error("Ошибка при создании постера:", error);
        }
    };
    const updatePoster = async (data) => {
        await axios.post(`${endpoints.POSTERS_UPDATE}`, data, { headers: headersFile });
        if (page == 1) {
            fetchPosters(page)
        }
        setPage(1);
        setPosters([]);
    };

    const deletePoster = async (id) => {
        await axios.delete(`${endpoints.POSTERS_DELETE}?id=${id}`, { headers });
        if (page == 1) {
            fetchPosters(page)
        }
        setPage(1);
        setPosters([]);
    };

    const resetCurrentItem = () => {
        setCurrentPoster(null)
    }

    useObserver(lastElement, page < totalPages, isLoading, () => { setPage(page + 1) })

    const getCurrentPoster = async (poster) => {
        setIsCurrentPosterLoading(true)
        try {
            const response = await axios.get(`${endpoints.POSTERS_BY_ID}${poster.idPoster}`, { headers });
            const combinedPoster = { ...poster, ...response.data };
            setCurrentPoster(combinedPoster);
            setIsCurrentPosterLoading(false)
        } catch (error) {
            console.error("Ошибка при получении текущего постера:", error);
        }
    }
    console.log(selectedCityId)
    return (
        <section className='manager'>
            <h1 className='manager__title'>Управление постерами</h1>

            {isCurrentPosterLoading ? <LoadingSpinner /> :
                <PosterForm poster={currentPoster} onSubmit={currentPoster ? updatePoster : createPoster} resetCurrentPoster={resetCurrentItem} />
            }
            <h2 className='manager__title_h2'>Список постеров</h2>

            <div className='citySelect'>
                <label htmlFor="citySelect__label">Выберите город:</label>
                <select id="citySelect_select" onChange={handleCityChange} value={selectedCityId || ''}>
                    {user.data.idCity == -1 &&
                        <option value="">Все города</option>
                    }
                    {cities.map(city => (
                        <option key={city.id} value={city.id}>{city.name}</option>
                    ))}
                </select>
            </div>

            <ul className='manager__ul'>
                {posters.map(poster => (
                    <li className='manager__li' key={poster.idPoster}>
                        {poster.posterName}
                        <div>
                            <button className='manager__button' onClick={() => getCurrentPoster(poster)}>Редактировать</button>
                            <button className='manager__button' onClick={() => deletePoster(poster.idPoster)}>Удалить</button>
                        </div>
                    </li>
                ))}
            </ul>
            <div ref={lastElement} style={{ height: 20 }}></div>
            {isLoading && <LoadingSpinner />}
        </section>
    );
};

export default PostersManager;